import { render, staticRenderFns } from "./cdm_deposit.vue?vue&type=template&id=47560326&"
import script from "./cdm_deposit.vue?vue&type=script&lang=js&"
export * from "./cdm_deposit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports